namespace AgerLMS {
    export interface SiteSettings {
        SiteUrl?: string;
        PlatformTitle?: string;
        PlatformEmail?: string;
        PlatformPhone?: string;
        PlatformLogo?: string;
        BigFooterLogo?: string;
        FooterLogo?: string;
        PlatformFavicon?: string;
        IyzcoLogo?: string;
        IsSidebarClosed?: boolean;
        BuyNowButton?: boolean;
        IsThereGuarantee?: boolean;
        GuaranteeText?: string;
        RegisterSmsText?: string;
        PlatformDescription?: string;
        GoogleSiteVerification?: string;
        AdditionalMetaTags?: string;
        AdditionalBodyTagsBefore?: string;
        AdditionalBodyTagsAfter?: string;
        AboutUsText?: string;
        AboutUsLink?: string;
        MembershipAgreementLink?: string;
        PrivacyAgreementLink?: string;
        DistanceSalesAgreementLink?: string;
        DeliveryAndReturnAgreementLink?: string;
        CookiePolicyLink?: string;
        KvkkLink?: string;
        ContactUsLink?: string;
        FaqLink?: string;
        FooterWarning?: string;
        ContactPageTitle?: string;
        ContactPageDescription?: string;
        ContactPageAddress?: string;
        ContactPageLatitude?: string;
        ContactPageLongitude?: string;
        IsMapShown?: boolean;
        InstagramLink?: string;
        YoutubeLink?: string;
        WhatsappLink?: string;
        TelegramLink?: string;
        EmailTo?: string;
        EmailBcc?: string;
        SupportPhone?: string;
        SupportEmail?: string;
        IsGraduationModuleActive?: boolean;
    }
}
